interface State {
  layout: any,
  botPlacement: any,
  widgetID: any,
  homeRoute: any,
  prefill: any,
  notice: any,
  menu: any,
  maintenance: any
}

export const useLayoutStore = defineStore('layout', {
  state: () => {
    return {
      layout: null,
      botPlacement: null,
      widgetID: null,
      homeRoute: null,
      prefill: null,
      notice: null,
      menu: false,
      maintenance: null
    } as State
  },
  actions:{
    setLayout (layout: any) {
      this.layout = layout
    },
    setWidgetID (widgetID: any) {
      this.widgetID = widgetID
    },
    setBotPlacement (placement: any) {
      this.botPlacement = placement
    },
    setHomeRoute (homeRoute: any) {
      this.homeRoute = homeRoute
    },
    setPrefill (prefill: any) {
      this.prefill = prefill
    },
    setNotice (notice: any) {
      this.notice = notice
    },
    setMenu (menu: any) {
      this.menu = menu
    },
    setMaintenance(maintenance: any) {
      this.maintenance = maintenance
    }
  }
})